import { render, staticRenderFns } from "./PaginaCabecalhoFooter.vue?vue&type=template&id=29dd71f6&scoped=true"
import script from "./PaginaCabecalhoFooter.vue?vue&type=script&lang=js"
export * from "./PaginaCabecalhoFooter.vue?vue&type=script&lang=js"
import style0 from "./PaginaCabecalhoFooter.vue?vue&type=style&index=0&id=29dd71f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dd71f6",
  null
  
)

export default component.exports